export default __webpack_public_path__ + "static/media/drizzle.0af7e137.svg";